export const SIGNAL_NAVIGATION_GROUPS = [
  "primary",
  "home",
  "scan-history",
  "tools",
  "utilities",
] as const;
export type SignalNavigationGroup = (typeof SIGNAL_NAVIGATION_GROUPS)[number];
export const SIGNAL_NAVIGATION_GROUP = {
  PRIMARY: "primary",
  HOME: "home",
  SCAN_HISTORY: "scan-history",
  TOOLS: "tools",
  UTILITIES: "utilities",
} as const satisfies Record<string, SignalNavigationGroup>;
